export const SOCIAL_IMAGE_WIDTH = 600;
export const SOCIAL_IMAGE_HEIGHT = 300;

type SocialImageCandidate = {
  croppedLogoUrl480?: string;
  croppedLogoUrl600?: string;
  croppedLogoUrl940?: string;
};

export function getSocialImageUrl(images?: SocialImageCandidate[]): string | undefined {
  return images
    ?.map((image) => image.croppedLogoUrl940 || image.croppedLogoUrl600 || image.croppedLogoUrl480)
    .find(Boolean);
}
